module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1051-2908753aef1582b155b5d6867f2a5446.png";